var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { prefectureList, } from '../consts/CommonConsts';
export const dayformat = (date) => {
    if (date === '') {
        return '';
    }
    const split_day = date.split(' ')[0];
    const year = split_day.split('-')[0];
    const month = split_day.split('-')[1];
    const day = split_day.split('-')[2];
    const split_time = date.split(' ')[1];
    const hour = split_time.split(':')[0];
    const minutes = split_time.split(':')[1];
    return year + '年' + month + '月' + day + '日 ' + hour + '時' + minutes + '分';
};
export const YMDHformat = (date) => {
    if (date === '') {
        return '';
    }
    const split_day = date.split(' ')[0];
    const year = split_day.split('-')[0];
    const month = split_day.split('-')[1];
    const day = split_day.split('-')[2];
    const split_time = date.split(' ')[1];
    const hour = split_time.split(':')[0];
    return year + '年' + month + '月' + day + '日 ' + hour + '時';
};
export const YMDformat = (date) => {
    if (date === '') {
        return '';
    }
    const year = date.split('-')[0];
    const month = date.split('-')[1];
    const day = date.split('-')[2];
    return year + '年' + month + '月' + day + '日';
};
export const YMDformatRaw = (date) => {
    if (date === '') {
        return '';
    }
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    return year + '年' + month + '月' + day + '日';
};
export const CardExpireFormat = (yymm) => {
    if (yymm === '' || yymm.length < 4) {
        return '';
    }
    const year = yymm.substring(0, 2);
    const month = yymm.substring(2, 4);
    return `${month}/${year}`;
};
export const PostalCodeFormat = (date) => {
    if (date === '') {
        return '';
    }
    if (date.length !== 7) {
        return '';
    }
    const front = date.substring(0, 3);
    const back = date.substring(3, 7);
    return front + '-' + back;
};
export const getValidationError = (colName, validationErrors) => {
    if (colName in validationErrors && validationErrors[colName].length > 0) {
        return validationErrors[colName][0];
    }
    return;
};
/**
 * 数値チェック関数
 * 入力値が数値 (符号あり小数 (- のみ許容)) であることをチェックする
 * [引数]   numVal: 入力値
 * [返却値] true:  数値
 *          false: 数値以外
 */
export const isNumber = (numVal) => {
    // チェック条件パターン
    var pattern = /^[+,-]?([1-9]\d*|0)(\.\d*)?$/;
    // 数値チェック
    return pattern.test(numVal);
};
//入力値の状態変更
export const inputChangeHandler = (e, value, setValue, setBeforeFunc) => {
    const target = e.target;
    const target_value = target.value;
    const name = target.name;
    if (target.type === 'checkbox') {
        const checked = target.checked;
        const nextChecks = value[name];
        //チェックボックス選択時
        if (checked) {
            if (nextChecks === null) {
                setValue(Object.assign(Object.assign({}, value), { [name]: [Number(target_value)] }));
            }
            else {
                const index = nextChecks.findIndex((check) => check == Number(target_value));
                if (index >= 0) {
                    return;
                }
                setValue(Object.assign(Object.assign({}, value), { [name]: [...nextChecks, Number(target_value)] }));
            }
        }
        else {
            //チェックボックス解除時
            const newChecks = nextChecks.filter(function (v) {
                return v !== Number(target_value);
            });
            setValue(Object.assign(Object.assign({}, value), { [name]: newChecks }));
        }
    }
    else {
        let _target_value = target_value;
        if (setBeforeFunc) {
            _target_value = setBeforeFunc(_target_value);
        }
        setValue(Object.assign(Object.assign({}, value), { [name]: _target_value }));
    }
};
// テキストエリアの状態変化
export const textareaChangeHandler = (e, value, setValue) => {
    const target = e.target;
    const target_value = target.value;
    const name = target.name;
    setValue(Object.assign(Object.assign({}, value), { [name]: target_value }));
};
//ファイルのオンチェンジハンドラ
export const fileInputChangeHandler = (e, setValue, checkType, checkTypeErrorHandler, checkSize, checkSizeErrorHandler) => {
    const target = e.target;
    const name = target.name;
    const file = e.target.files;
    if (file === null) {
        setValue(null);
        return false;
    }
    if (file.length === 0) {
        setValue(null);
        return false;
    }
    if (checkType && file[0].type !== checkType) {
        if (checkTypeErrorHandler) {
            checkTypeErrorHandler();
        }
        setValue(null);
        return;
    }
    if (checkSize && file[0].size > checkSize) {
        if (checkSizeErrorHandler) {
            checkSizeErrorHandler();
        }
        setValue(null);
        return;
    }
    const clone = (file) => __awaiter(void 0, void 0, void 0, function* () {
        const buffer = yield file.arrayBuffer();
        return new File([buffer], file.name, { type: file.type });
    });
    clone(file[0])
        .then(result => setValue(result))
        .catch(err => {
        throw err;
    });
};
//配列からstringを返す
export const ArrayToStringFunc = (array_value, list_value, prefix = '・', separater = ' ', lastSeparater = true) => {
    var _a;
    let return_strings = '';
    if (array_value !== null && typeof array_value !== 'undefined') {
        const last_key = array_value.length;
        let k = 1;
        for (const condition of array_value) {
            return_strings =
                return_strings + prefix + ((_a = list_value.find((element) => element.key === Number(condition))) === null || _a === void 0 ? void 0 : _a.value) + ((k !== last_key || lastSeparater) ? separater : '');
            k++;
        }
    }
    return return_strings;
};
export const NotificationDateformat = (date) => {
    if (typeof date === "undefined" || date === null || date === "") {
        return "";
    }
    const NotificationDate = date.replace(/-/g, '.');
    return NotificationDate;
};
export const GenerateUuid = () => {
    const strong = 1000;
    const uuid = new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16);
    return uuid;
};
// 配列を指定数Nずつに分割
// ex [1,2,3,4,5,6,7] => [[1,2], [3, 4], [5,6], [7]]
export const ArraySplit = (array, n) => array.reduce((a, c, i) => i % n == 0 ? [...a, [c]] : [...a.slice(0, -1), [...a[a.length - 1], c]], []);
// 都道府県番号を都道府県名に変換する
export const getPrefectureName = (key) => {
    const data = prefectureList.find((pre) => pre.key === key);
    if (!data) {
        return '';
    }
    return data.value;
};
//number_format
export const StringToNumberFormatFunction = (value) => {
    if (value === null) {
        return '';
    }
    const string = typeof value === 'number' ? String(value) : value;
    const number = string.replace(/[^0-9]/g, '');
    const number_format = number.toString().replace(/(\d+?)(?=(?:\d{3})+$)/g, function (x) {
        return x + ',';
    });
    const rep_string = string.replace(/[0-9]/g, '');
    return number_format + rep_string;
};
/**
 * 画像ファイルのサイズを取得する
 */
export const ImageSizeGet = (file) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const size = {
                width: img.naturalWidth,
                height: img.naturalHeight,
            };
            URL.revokeObjectURL(img.src);
            resolve(size);
        };
        img.onerror = (error) => {
            reject(error);
        };
        img.src = URL.createObjectURL(file);
    });
});
// ソート条件判定汎用関数
export const sortCompare = (x, y, lower, higher) => {
    if (lower(x, y))
        return -1;
    if (higher(x, y))
        return 1;
    return 0;
};
export const shuffleArray = ([...array]) => {
    for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};
